import { useEffect, useRef } from "react";

const useDebounce = (effect: () => void, delay: number, deps: any[] = []) => {
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		// Clear the previous timeout
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Set a new timeout
		timeoutRef.current = setTimeout(() => {
			effect();
		}, delay);

		// Cleanup the timeout on unmount or dependency change
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, [...deps, delay]); // Include delay in dependencies
};

export default useDebounce;
